import React, { useState } from "react";
import axios from "axios";
import { Mail, MapPin, Phone } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const submit = async (event) => {
    event.preventDefault();
    await axios.post(`${API}/contact`, form);
    setSent(true);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <main className="bg-[#FAFAF8] pt-32" data-testid="contact-page">
      <section className="mx-auto grid max-w-7xl gap-10 px-6 pb-24 md:grid-cols-12 md:px-10 md:pb-32">
        <div className="md:col-span-5">
          <SectionHeading eyebrow="Contact" title="Bring the hills to your city kitchen." copy="For harvest questions, chef orders, city deliveries or farmer impact conversations, write to us." testId="contact-heading" />
          <div className="space-y-4">
            <p data-testid="contact-location" className="flex gap-3 text-[#6B6B66]"><MapPin className="h-5 w-5 text-[#4F795B]" /> Tatva Hills, Uttarakhand</p>
            <p data-testid="contact-email" className="flex gap-3 text-[#6B6B66]"><Mail className="h-5 w-5 text-[#4F795B]" /> care@tatvahillsagro.com</p>
            <p data-testid="contact-phone" className="flex gap-3 text-[#6B6B66]"><Phone className="h-5 w-5 text-[#4F795B]" /> +91 92660 19419</p>
          </div>
        </div>
        <form data-testid="contact-form" onSubmit={submit} className="rounded-[2rem] bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] md:col-span-7">
          <div className="grid gap-5 md:grid-cols-2">
            <label className="text-sm font-medium text-[#4A3B32]">Name
              <input data-testid="contact-name-input" required value={form.name} onChange={(event) => update("name", event.target.value)} className="mt-2 h-12 w-full rounded-full border border-[#D5D5D0] bg-[#FAFAF8] px-4 outline-none" />
            </label>
            <label className="text-sm font-medium text-[#4A3B32]">Email
              <input data-testid="contact-email-input" required type="email" value={form.email} onChange={(event) => update("email", event.target.value)} className="mt-2 h-12 w-full rounded-full border border-[#D5D5D0] bg-[#FAFAF8] px-4 outline-none" />
            </label>
            <label className="text-sm font-medium text-[#4A3B32] md:col-span-2">Message
              <textarea data-testid="contact-message-input" required value={form.message} onChange={(event) => update("message", event.target.value)} className="mt-2 min-h-40 w-full rounded-[1.5rem] border border-[#D5D5D0] bg-[#FAFAF8] p-4 outline-none" />
            </label>
          </div>
          <button data-testid="contact-submit-button" type="submit" className="mt-7 inline-flex rounded-full bg-[#2A4B3C] px-8 py-4 font-medium text-white transition-transform duration-300 hover:-translate-y-1">Send Message</button>
          {sent && <p data-testid="contact-success-message" className="mt-5 text-[#4F795B]">Your message has been received.</p>}
        </form>
      </section>
    </main>
  );
}